import React from 'react';
import { PACK_BRANDS, packColor } from './packBrands';

/** Decorative: the pack's name always sits beside it. A pack with no logo shows its first letter. */
export default function PackLogo({ id, title, size = 'medium' }) {
  const brand = PACK_BRANDS[id];
  return (
    <span className={`pack-logo pack-logo-${size}`} style={{ '--pack-color': packColor(id) }} aria-hidden="true">
      {brand?.logo ? <img src={brand.logo} alt="" /> : <span className="pack-logo-letter">{String(title || id || '?').charAt(0).toUpperCase()}</span>}
    </span>
  );
}
